module.exports = __webpack_public_path__ + "img/bgImg.1ff71509.png";